import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getRoleList } from '../../actions/permissionsAction'
import ListRolesView from '../../containers/Roles/ListRoles/ListRoles'

const ListRoles = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const {listRoleAdmin} = useSelector(state=>state.permissionsAdmin)
    useEffect(() => {
      dispatch(getRoleList(history))
    
      return () => {
        
      }
    }, [])
    
  return (
    <ListRolesView roles={listRoleAdmin} />
  )
}

export default ListRoles